/* ==========================================================================
   Irrigation Supply — site behaviour
   Progressive enhancement only: every page is usable with JS disabled.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------------------------------------------------------------
     1. Mobile drawer
     --------------------------------------------------------------- */
  function initDrawer() {
    var drawer = $('#site-drawer');
    if (!drawer) return;
    var lastFocus = null;

    function setOpen(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
      $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        lastFocus = document.activeElement;
        var first = $('.drawer__panel a, .drawer__panel button', drawer);
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }

    $$('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(drawer.getAttribute('data-open') !== 'true'); });
    });
    $$('[data-drawer-close]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') setOpen(false);
    });

    /* Collapsible groups inside the drawer */
    $$('[data-drawer-toggle]', drawer).forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = true;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  }

  /* ---------------------------------------------------------------
     2. Accordions (FAQ / advice)
     --------------------------------------------------------------- */
  function initAccordions() {
    $$('.accordion__trigger').forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!open));
        panel.setAttribute('data-open', String(!open));
      });
    });
  }

  /* ---------------------------------------------------------------
     3. FAQ category filter
     --------------------------------------------------------------- */
  function initFaqFilter() {
    var nav = $('.faq-nav');
    if (!nav) return;
    var buttons = $$('button', nav);
    var items = $$('.accordion__item[data-category]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-category');
        buttons.forEach(function (b) { b.setAttribute('aria-selected', String(b === btn)); });
        items.forEach(function (item) {
          var match = cat === 'all' || item.getAttribute('data-category') === cat;
          item.hidden = !match;
        });
        /* Keep every visible group heading in sync */
        $$('.accordion').forEach(function (acc) {
          var visible = $$('.accordion__item:not([hidden])', acc).length;
          var group = acc.closest('[data-faq-group]');
          if (group) group.hidden = visible === 0;
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     4. Tabs (product detail)
     --------------------------------------------------------------- */
  function initTabs() {
    $$('.tabs').forEach(function (tablist) {
      var tabs = $$('button', tablist);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', String(on));
            var p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.setAttribute('data-open', String(on));
          });
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     5. Product gallery thumbnails
     --------------------------------------------------------------- */
  function initGallery() {
    var main = $('#pdp-main-image');
    if (!main) return;
    $$('.pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $$('.pdp__thumb').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
        var src = thumb.getAttribute('data-image');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) { main.setAttribute('src', src); main.setAttribute('alt', alt); }
      });
    });
  }

  /* ---------------------------------------------------------------
     6. Quantity stepper
     --------------------------------------------------------------- */
  function initQty() {
    $$('.qty').forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      $$('button', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
        });
      });
    });
  }

  /* ---------------------------------------------------------------
     7. Demo cart counter
     Placeholder only — replaced by Shopify's real cart once live.
     --------------------------------------------------------------- */
  function initCart() {
    var count = $('#cart-count');
    if (!count) return;
    $$('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var qtyInput = $('.qty input');
        var add = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        count.textContent = String((parseInt(count.textContent, 10) || 0) + add);
        var original = btn.innerHTML;
        btn.innerHTML = '<svg class="icon" aria-hidden="true"><use href="#i-check"></use></svg> Added to enquiry';
        btn.setAttribute('disabled', 'disabled');
        setTimeout(function () { btn.innerHTML = original; btn.removeAttribute('disabled'); }, 2200);
      });
    });
  }

  /* ---------------------------------------------------------------
     8. Forms — client-side validation + demo confirmation
     --------------------------------------------------------------- */
  function initForms() {
    $$('form[data-demo-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var success = $('.form-success', form);
        if (success) {
          success.setAttribute('data-show', 'true');
          success.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
        form.reset();
      });
    });
  }

  /* ---------------------------------------------------------------
     9. Collection filters toggle (mobile)
     --------------------------------------------------------------- */
  function initFilters() {
    var toggle = $('[data-filters-toggle]');
    var panel = $('#collection-filters');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.getAttribute('data-open') === 'true';
      panel.setAttribute('data-open', String(!open));
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------------------------------------------------------------
     10. Back to top
     --------------------------------------------------------------- */
  function initToTop() {
    var btn = $('.to-top');
    if (!btn) return;
    var onScroll = function () {
      btn.setAttribute('data-show', window.scrollY > 700 ? 'true' : 'false');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    onScroll();
  }

  /* ---------------------------------------------------------------
     11. Footer year + active nav
     --------------------------------------------------------------- */
  function initChrome() {
    $$('[data-year]').forEach(function (el) { el.textContent = String(new Date().getFullYear()); });

    var here = (location.pathname.split('/').pop() || 'index.html').toLowerCase();
    $$('.nav__link[href], .drawer__link[href]').forEach(function (link) {
      var target = (link.getAttribute('href') || '').split('/').pop().split('#')[0].toLowerCase();
      if (target && target === here) link.setAttribute('aria-current', 'page');
    });
  }

  /* ---------------------------------------------------------------
     Boot
     --------------------------------------------------------------- */
  function boot() {
    initDrawer();
    initAccordions();
    initFaqFilter();
    initTabs();
    initGallery();
    initQty();
    initCart();
    initForms();
    initFilters();
    initToTop();
    initChrome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
